import React from "react";
import { ButtonPrimary } from "@primer/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDiscord, faGithubSquare } from "@fortawesome/free-brands-svg-icons";

function Footer() {
  return (
    <>
      <section className="fdb-block">
        <div className="container">
          <div className="row justify-content-center ">
            <div className="col-12 col-lg-8 col-xl-6 text-center">
              <h1 className="mt-4">Make your contribution</h1>
              <p className="lead">
                Small experiments, inspired inventions, and the software
                everyone depends on—the code you write on GitHub can reach one
                codebase or millions.
              </p>

              <p className="h3 mt-4 mb-5">
                <ButtonPrimary backgroundColor={"purple"}>
                  <a
                    id="explore"
                    target="_blank"
                    href="https://discord.gg/XGKsuazjk7"
                    rel="noreferrer"
                  >
                    <FontAwesomeIcon icon={faDiscord} /> &nbsp; Join our Discord
                  </a>
                </ButtonPrimary>{" "}
                <ButtonPrimary>
                  <a
                    id="explore"
                    target="_blank"
                    href="https://education.github.com/discount_requests/student_application?utm_source=2021-10-10-openhackdaylk"
                    rel="noreferrer"
                  >
                    <FontAwesomeIcon icon={faGithubSquare} /> &nbsp; Get GitHub
                    Student Pack
                  </a>
                </ButtonPrimary>
              </p>
            </div>
          </div>
        </div>
      </section>

      <div id="wrapper">
        <div id="container">
          <p id="footer">
            Made with ❤️ by{" "}
            <a href="https://github.com/GitHubExperts-LK" id="hyper">
              GitHub Community Sri Lanka
            </a>
          </p>
        </div>
      </div>
      <div id="footer"></div>
    </>
  );
}

export default Footer;
